import React from 'react'
import { useEffect, useState } from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { Peginationcomponent } from '../../../../Component/Peginationcomponent'
import Loading from '../../../../Component/Loading'
import useReduxData from '../../../../Hooks/useReduxData'
import { IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import useTableSorting from '../../../../Hooks/useTableSorting'
import { STOCK_HISTORY_INVENTORY } from '../../../Repository/SettingRepo'
import { NoRecordFound } from '../../../../Component/NoRecordFound'
import moment from 'moment-timezone'

const StockHistory = () => {

    const [historyData, setHistoryData] = useState([])
    const navigate = useNavigate()
    const { id } = useParams()
    const [loader, setLoader] = useState(false)
    const [TotalCount, setTotalCount] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: null });
    const { reduxData: userData } = useReduxData("userDataRDX")
    const [Filter, setFilter] = useState({
        archive: true,
        search: "",
        disable_button: true
    })

    const headCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", isShorted: false },
        { id: "date", numeric: true, disablePadding: false, label: "Date", isShorted: true },
        { id: "time", numeric: true, disablePadding: false, label: "Time", isShorted: true },
        { id: "action", numeric: true, disablePadding: false, label: "Action", isShorted: true },
        { id: "quantity", numeric: true, disablePadding: false, label: "Quantity", isShorted: true },
    ];

    const getStockHistory = async () => {
        setLoader(true)
        const { page, rowsPerPage, searchPage } = controller;
        const { search } = Filter;
        const keyword = search.trim();
        let payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            page: page,
            count: rowsPerPage,
            inventoryId: id,
        }
        setLoader(true)
        try {
            let response = await STOCK_HISTORY_INVENTORY(payload)
            setHistoryData(response?.data)
            setTotalCount(response?.totalCount)
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setHistoryData([])
            setTotalCount(0)
            setLoader(false)
        }
    }

    const { EnhancedTableHead, order, orderBy, stableSort, getComparator, handleRequestSort } = useTableSorting(headCells)


    useEffect(() => {
        getStockHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller]);

    return (
        <>
            {loader && <Loading />}
            <div className="common-component-box">
                <header className="body_header">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
                        <div className="d-flex align-items-center mb-2 mb-md-0">
                            <FaArrowLeft
                                className="me-2 cursor"
                                onClick={() => navigate("/setting/inventory", { state: { tab: 2 } })}
                                role="button"
                                aria-label="Go Back"
                                title="Go Back"
                                style={{ fontSize: "1.2rem" }}
                            />
                            <h2 className="page_name mb-0">Stock History</h2>
                        </div>
                    </div>
                </header>
                {/* </div> */}

                <div className="row common-white-bg-box mx-0 shadow d-flex align-content-start  position-relative px-2">
                    <div className=" py-2" style={{ height: "100%" }}>
                        {/* <div className='pb-2 d-flex justify-content-between ' style={{ borderBottom: "2px solid #ededed" }}>
                            <ul className="headerlist px-0">
                            <li className='me-2' style={{ width: "210px" }}> <input type="text" placeholder="Search" className="form-control filter_input" name='search' value={Filter?.search} onChange={handleChangeFilter} /> </li>

                            <li className="me-2" style={{ width: 150 }}>
                                <SelectBox
                                    placeholder="Select"
                                    value={Filter?.archive}
                                    name="archive"
                                    keys="value"
                                    label="label"
                                    menuValeu="value"
                                    handleChange={handleChangeFilter}
                                    option={activeStatusOption}
                                />
                            </li> 
                            <li className='me-2'><CustomButton disabled={Filter?.disable_button} startIcon={<IoIosSearch />} variant="contained" onClick={HandleSearchList}>search</CustomButton></li>
                           
                        </ul>
                        </div> */}
                        <div className="row" >
                            <div className="col-12 h-100 pt-3">

                                <TableContainer   >
                                    {historyData.length === 0 && <div className="col-sm-12 mt-3 text-center " > <NoRecordFound /> </div>}
                                    <Table
                                        id="table_mui"
                                        aria-labelledby="tableTitle"
                                        size={"medium"}
                                        aria-label="enhanced table" >
                                        {
                                            historyData?.length !== 0 && <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={historyData?.length} />
                                        }
                                        <TableBody className="table_overflow_scroll" >
                                            {stableSort(historyData, getComparator(order, orderBy)).map(
                                                (row, index) => {
                                                    const labelId = `enhanced-table-checkbox-${index}`;
                                                    return <React.Fragment key={index}><TableRow id="hover_tr" style={{ cursor: 'pointer' }}>
                                                        <TableCell className="ps-3" component="th" id={labelId} scope="row" padding="none" >
                                                            {controller?.rowsPerPage * (controller?.page - 1) + index + 1}
                                                        </TableCell>
                                                        <TableCell id={labelId}>
                                                            {row?.createdOn
                                                                ? moment(row?.createdOn).tz(userData?.timezoneName || moment.tz.guess()).format('ll')
                                                                : 'N/A'}
                                                        </TableCell>
                                                        <TableCell id={labelId} align="left">
                                                            {(row?.createdOn)
                                                                ? moment(row?.createdOn).tz(userData?.timezoneName || moment.tz.guess()).format('LT')
                                                                : 'N/A'}
                                                        </TableCell>
                                                        <TableCell id={labelId} align="left">
                                                            <span className={row?.action === "add" ? "text-success" : "text-danger"}>
                                                                {row?.action === "add" ? "ADD" : "RELEASE"}
                                                            </span>
                                                        </TableCell>

                                                        <TableCell id={labelId} align="left" >
                                                            <span className={row?.action === "add" ? "text-success" : "text-danger"}>
                                                                {row?.action === "add" ? `+${row?.quantity || ""}` : `-${row?.quantity || ""}`}
                                                            </span>
                                                        </TableCell>
                                                    </TableRow>
                                                    </React.Fragment>
                                                }
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <nav className=" w-100  " aria-label="pagination">
                                {TotalCount > 10 && <Peginationcomponent count={TotalCount} controller={controller} setController={setController} />}
                            </nav>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default StockHistory